import { app } from '@microsoft/teams-js';

const SUPPORT_EMAIL = 'help@trovve.com';
const SUPPORT_SUBJECT = 'Trovve Support Request';
const OUTLOOK_COMPOSE_URL = 'https://outlook.office.com/mail/deeplink/compose';

/** Optional prefill for the support draft. Omitted fields fall back to the plain "Trovve Support Request" draft. */
export interface SupportEmailDraft {
    subject?: string;
    body?: string;
}

/**
 * Opens a new draft to help@trovve.com in Outlook on the web, from the signed-in user's own mailbox. The user sends it.
 *
 * Outlook on the web everywhere, not mailto: a mailto link does nothing at all when the browser / OS has no default
 * mail app (common for web-only Microsoft 365 users), and Teams' sandboxed tab iframe blocks mailto outright. Every
 * Trovve user has an M365 mailbox, so the compose deep link always opens a visible draft.
 *  - Inside Teams: app.openLink, which Teams opens outside its iframe.
 *  - In a browser: a new tab, opened synchronously from the user's click so popup blockers allow it.
 */
export function openSupportEmail(draft?: SupportEmailDraft): void {
    const isInTeams = window !== window.parent && !window.opener;
    const composeUrl =
        OUTLOOK_COMPOSE_URL +
        '?to=' +
        encodeURIComponent(SUPPORT_EMAIL) +
        '&subject=' +
        encodeURIComponent((draft && draft.subject) || SUPPORT_SUBJECT) +
        (draft && draft.body ? '&body=' + encodeURIComponent(draft.body) : '');

    if (isInTeams) {
        app.openLink(composeUrl).catch(() => window.open(composeUrl, '_blank'));
        return;
    }
    window.open(composeUrl, '_blank', 'noopener');
}
